
import { SELECT_SHIPPING_METHOD } from '../../GlobalStateContainer'
/* SHIPPING METHOD */

export function selectShippingMethod(shippingMethodId) {
  return { type: SELECT_SHIPPING_METHOD, shippingMethodId }
}
